import request from '@/utils/request'

// 获得协议
export function getAgreement(data) {
	return request({
		url:'/app-api/biz/home/get-agreement',
		method: 'get',
		params: data
	})
}
// 用户发票列表
export function getInvoiceList(data) {
	return request({
		url:'/app-api/biz/my/get-user-invoice-page',
		method: 'get',
		params: data
	})
}

// 待开发票订单
export function getOrderList(data) {
	return request({
		url:'/app-api/biz/my/get-user-invoice-order',
		method: 'post',
		params: data
	})
}
// 用户发票申请
export function getApply(data) {
	return request({
		url:'/app-api/biz/my/user-invoice-apply',
		method: 'post',
		data
	})
    
}
// 获得用户发票
export function getInvoiceDetail(data) {
	return request({
		url:'/app-api/biz/my/get-user-invoice',
		method: 'get',
		params: data
	})
}
// 查询证书
export function getCert(data) {
	return request({
		url:'/app-api/biz/my/get-certificate',
		method: 'get',
		params: data
	})
}
// 查看发票关联订单
export function getInvoiceOrder(data) {
	return request({
		url:'/app-api/biz/my/get-invoice-order',
		method: 'get',
		params: data
	})
}
// 获得会员分页
export function getLevelPage(data) {
	return request({
		url:'/app-api/biz/my/get-level-page',
		method: 'get',
		params: data
	})
}
// 创建会员订单
export function getMemberOrder(data) {
	return request({
		url:'/app-api/biz/my/create-member-order',
		method: 'post',
		data
	})
    
}
// 获得用户会员
export function getMyLevel(data) {
	return request({
		url:'/app-api/biz/my/my-level',
		method: 'get',
		params: data
	})
}
// 获得支付订单--会员状态查询
export function getMyVip(data) {
	return request({
		url:'/app-api/pay/order/get',
		method: 'get',
		params: data
	})
}
// 更新用户会员告知书
export function getNotification(data) {
	return request({
		url:'/app-api/biz/my/update-level-notification',
		method: 'put',
		data
	})
}
// 获得会员订单分页
export function getRecord(data) {
	return request({
		url:'/app-api/biz/my/get-member-order-page',
		method: 'get',
		params: data
	})
}

// 获得会员订单分页
export function getWildRecord(data) {
	return request({
		url:'/app-api/biz/my/get-member-wild-order-page',
		method: 'get',
		params: data
	})
}

// 订单退款
export function getRefund(data) {
	return request({
		url:'/app-api/biz/my/order-refund',
		method: 'get',
		params: data
	})
}

// 获得我报名的活动
export function getMyActivity(data) {
	return request({
		url:'/app-api/biz/my/get-my-activity',
		method: 'get',
		params: data
	})
}

// 图片Base64
export function getBase64(data) {
	return request({
		url:'/app-api/biz/my/get-base64',
		method: 'post',
		params: data
	})
}